<template>
  <div>

    <!-- //FILTRO -->
    <div class="row">
      <div class="col-md-12 text-right" style="flex-wrap: wrap; margin-bottom: 10px">
        <btn-rounded class="text-right" :label="filter ? 'LIMPAR' : 'FILTRO'" event="showFilter"
          :active-color="filter ? 'danger' : 'primary'" />
      </div>


      <div v-if="filter">
        <div class="row" style="padding: 20px" text-center>
          <div class="col-md-6">
            <fg-input type="text" label="Busca" placeholder="Nome, Email..." v-model="filterOptions.term" />
          </div>
          <div class="col-md-6" style="margin-top: 25px;">
            <btn-rounded class="text-right" label="FILTRAR" event="activeFilter" active-color="success" />
          </div>
        </div>
      </div>
    </div>
    <!-- FILTRO// -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <component-table eventName="selectItem" :title="table.title" :sub-title="table.subTitle" :data="userlist"
            :columns="table.columns" :headers="table.headers" />
        </div>
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
import { mapActions, mapState } from "vuex";
import moment from 'moment';

const headers = ["Nome", "Email", "Data Cadastro", "Status"];
const tableColumns = [
  "name", "email",
  {
    columnName: "createdAt",
    logic: function (data) {
      if (!data) return '';
      return moment.utc(data).utcOffset(-180).format('D/M/YYYY H:mm:ss');
    }
  },
  {
    columnName: "isActive",
    logic: function (data) {
      let className = 'text-danger';
      let val = 'Suspenso';
      if (data) {
        className = 'text-success';
        val = 'Ativo';
      }
      let prefix = `<span class="${className}" style="font-size:large">&bullet;</span>`;
      return `${prefix} ${val}`
    }
  }
];

export default {
  components: {
    ComponentTable
  },
  computed: {
    ...mapState({
      userlist: state => state.user.list
    })
  },
  data() {
    return {
      table: {
        title: "Selecionar Usuário para VIP",
        subTitle: "Busque um comprador para tornar VIP",
        headers: [...headers],
        columns: [...tableColumns],
      },
      filter: false,
      filterOptions: {
        isActive: true,
        isSeller: false,
        term: undefined,
      },
    };
  },
  methods: {
    ...mapActions(["getUserList", "createVip"]),

    cleanFilter() {
      this.filterOptions.term = undefined;
      this.initData();
    },

    initData() {
      return this.getUserList(this.filterOptions);
    }
  },
  created() {
    this.initData();

    this.$on("showFilter", () => {
      if (this.filter) this.cleanFilter();
      this.filter = !this.filter;
    });

    this.$on("activeFilter", () => {
      if (!!this.filterOptions.term && this.filterOptions.term.length < 3) {
        return this.$notify({
          group: "foo",
          title: "Busca inválida",
          text: "Mínimo de 3 caracteres",
          position: "top center",
          type: "error",
        });
      }
      this.initData();
    });

    this.$on("selectItem", (user) => {
      this.$modal.show('dialog', {
        title: 'Adicionar VIP',
        text: `Deseja adicionar ${user.name} à lista VIP?`,
        buttons: [{
          title: 'Sim',
          handler: () => {

            this.createVip({ BuyerId: user.id })
              .then(res => {
                this.$notify({
                  group: "foo",
                  title: "Sucesso",
                  text: "Usuário agora é VIP",
                  position: "top center",
                  type: "success"
                });
                this.$router.push("/admin/vip/lista");
              })
              .catch(err => {
                this.$notify({
                  group: "foo",
                  title: "Erro",
                  text: err.info || "Não foi possível adicionar o usuário ao VIP",
                  position: "top center",
                  type: "error"
                });
              });

            this.$modal.hide('dialog')

          }

        },
        {
          title: 'Não', // Button title
          handler: () => {

            this.$modal.hide('dialog')
          } // Button click handler
        }

        ]
      });
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Vip/VipCreate.vue